import React, { Component } from "react";
import { Table, Button, Col, Tooltip, Row, Modal, DatePicker } from "antd";
import axios from "axios";
import "./Pages.css";
import VendasVendedoresPrintModal from "../relatorios/VendasVendedoresPrintModal";
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario } from "../utils/LoginManager";
import FiltrosForm from '../components/FiltrosForm';
import Colors from "../utils/Colors";

const dateFormat = 'DD/MM/YYYY'
const { RangePicker } = DatePicker;
const { Column } = Table;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,

    vendasTotais: 0,
    meta: 0,

    vlrJan: 0,
    vlrFev: 0,
    vlrMar: 0,
    vlrAbr: 0,
    vlrMai: 0,
    vlrJun: 0,
    vlrJul: 0,
    vlrAgo: 0,
    vlrSet: 0,
    vlrOut: 0,
    vlrNov: 0,
    vlrDez: 0,

    formFiltroVisivel: false,
    filtros: {
      tipoTela: 'METAS',
      buscaOrdem: { campo: 'usu_nome', ordem: 'ASC' },
      buscaDataIni: '',
      buscaDataFim: '',
      buscaMes: 0, //new Date().getMonth() + 1,
      buscaAno: new Date().getFullYear(),
      buscaPessoa: { key: '0', },
      buscaUsuario: { key: '0', },
      buscaMunicipio: { key: '0', },
      buscaGrupoProduto: { key: '0' },
      buscaProduto: { key: '0' },
      buscaTipo: { key: 'X' },
      buscaControle: '',
      buscaAtividade: { key: '0', },
      buscaTipoAtiv: { key: 'X' },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({
      usuario,
    }, this.getListaRegistros);
  }

  componentDidUpdate(antProps, antState) {
    // const { total, pagina, limite } = this.state;
    // const ultimaPagina = Math.ceil(total / limite);
    // if (pagina > 1 && pagina > ultimaPagina) {
    //   this.setState({
    //     pagina: ultimaPagina
    //   }, this.getListaRegistros)
    // }
  }


  getListaRegistros = () => {
    this.setState({
      listaRegistros: [], carregando: true,
      vlrJan: 0, vlrFev: 0, vlrMar: 0, vlrAbr: 0, vlrMai: 0, vlrJun: 0,
      vlrJul: 0, vlrAgo: 0, vlrSet: 0, vlrOut: 0, vlrNov: 0, vlrDez: 0,
    });
    const { buscaOrdem, buscaAno, buscaMes, buscaUsuario } = this.state.filtros;

    if ((buscaAno) || (buscaMes)) {

      axios
        .get('/vendas/listaMetasVendedores', {
          params: {
            campoOrdem: buscaOrdem.campo,
            tipoOrdem: buscaOrdem.ordem,
            ano: buscaAno,
            mes: buscaMes,
            usuario: buscaUsuario.key,
          }
        })
        .then(response => {
          this.setState({
            listaRegistros: response.data.dados,
            carregando: false,

            vendasTotais: response.data.vendasTotais,
            meta: response.data.meta,

            vlrJan: response.data.Vjan,
            vlrFev: response.data.Vfev,
            vlrMar: response.data.Vmar,
            vlrAbr: response.data.Vabr,
            vlrMai: response.data.Vmai,
            vlrJun: response.data.Vjun,
            vlrJul: response.data.Vjul,
            vlrAgo: response.data.Vago,
            vlrSet: response.data.Vset,
            vlrOut: response.data.Vout,
            vlrNov: response.data.Vnov,
            vlrDez: response.data.Vdez,

            MetaJan: response.data.Mjan,
            MetaFev: response.data.Mfev,
            MetaMar: response.data.Mmar,
            MetaAbr: response.data.Mabr,
            MetaMai: response.data.Mmai,
            MetaJun: response.data.Mjun,
            MetaJul: response.data.Mjul,
            MetaAgo: response.data.Mago,
            MetaSet: response.data.Mset,
            MetaOut: response.data.Mout,
            MetaNov: response.data.Mnov,
            MetaDez: response.data.Mdez,
          });

        })
        .catch(erro => {
          console.warn(erro);
          this.setState({
            carregando: false,
          });
        });
    } else {
      this.setState({
        listaRegistros: [],
        carregando: false,
      });
    }
  };




  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { filtros } = this.state;
    filtros[id] = value;
    this.setState({
      [id]: value
    },
      this.getListaRegistros
    );
  };


  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaMes: this.state.filtros.buscaMes,
        buscaAno: this.state.filtros.buscaAno,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaMunicipio: this.state.filtros.buscaMunicipio,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaTipo: this.state.filtros.buscaTipo,
        buscaControle: this.state.filtros.buscaControle,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };


  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };

  renderData = (data, registro) => {
    let dataMoment = '';
    if ((registro.ultVenda) && (registro.ultOS)) {
      if (moment(registro.ultVenda) > moment(registro.ultOS)) {
        dataMoment = moment(registro.ultVenda);
      } else {
        dataMoment = moment(registro.ultOS);
      }
    } else if (registro.ultVenda) {
      dataMoment = moment(registro.ultVenda);
    } else if (registro.ultOS) {
      dataMoment = moment(registro.ultOS);
    }
    return (
      <span>
        {dataMoment ? dataMoment.format('DD/MM/YYYY') : ''}
      </span>
    )
  }


  renderValor = (vlr) => {
    return (
      <span> {numeral(vlr).format('0,000.00')} </span>
    );
  };

  renderResultado = (vlr, registro) => {
    const meta = registro.vendasTotais > registro.meta ? 1 : 0;
    return (
      <div style={{ height: 30, width: 30, borderRadius: 50, backgroundColor: meta ? "#10734a" : "#b71c1c" }} />
    );
  };

  renderValor01 = (vlr, registro) => {
    const meta = registro.vendas01 > registro.meta01 ? 1 : 0;
    return (
      <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
    );
  };

  renderValor02 = (vlr, registro) => {
    const meta = registro.vendas02 > registro.meta02 ? 1 : 0;
    return (
      <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
    );
  };

  renderValor03 = (vlr, registro) => {
    const meta = registro.vendas03 > registro.meta03 ? 1 : 0;
    return (
      <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
    );
  };

  renderValor04 = (vlr, registro) => {
    const meta = registro.vendas04 > registro.meta04 ? 1 : 0;
    return (
      <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
    );
  };

  renderValor05 = (vlr, registro) => {
    const meta = registro.vendas05 > registro.meta05 ? 1 : 0;
    return (
      <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
    );
  };

  renderValor06 = (vlr, registro) => {
    const meta = registro.vendas06 > registro.meta06 ? 1 : 0;
    return (
      <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
    );
  };

  renderValor07 = (vlr, registro) => {
    const meta = registro.vendas07 > registro.meta07 ? 1 : 0;
    return (
      <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
    );
  };

  renderValor08 = (vlr, registro) => {
    const meta = registro.vendas08 > registro.meta08 ? 1 : 0;
    return (
      <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
    );
  };

  renderValor09 = (vlr, registro) => {
    const meta = registro.vendas09 > registro.meta09 ? 1 : 0;
    return (
      <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
    );
  };

  renderValor10 = (vlr, registro) => {
    const meta = registro.vendas10 > registro.meta10 ? 1 : 0;
    return (
      <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
    );
  };

  renderValor11 = (vlr, registro) => {
    const meta = registro.vendas11 > registro.meta11 ? 1 : 0;
    return (
      <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
    );
  };

  renderValor12 = (vlr, registro) => {
    const meta = registro.vendas12 > registro.meta12 ? 1 : 0;
    return (
      <span style={{ color: meta ? "#10734a" : "#b71c1c" }}> {numeral(vlr).format('0,000.00')} </span>
    );
  };


  onTabelaChange = (pagination => {

  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, filtros, formFiltroVisivel } = this.state;
    const { buscaAno, buscaMes } = this.state.filtros;

    // console.log('VendasVendedoresPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <h2 className="tituloPage">Vendas por Vendedores</h2>
        <hr />
        <br />

        <Row>
          <div className="pageFiltro" style={{ height: 20 }}>
            <Col xs={24} >

              <Row xs={24} style={{}}>
                <Col xs={2} style={{ width: 110, marginTop: -7 }}>
                  <Button
                    onClick={this.onAbrirFiltroClick}
                    className="pageFiltro-filtrar"
                    style={{ marginRight: 15 }}
                  >
                    Filtrar
                  </Button>
                </Col>

                <FiltrosForm
                  visivel={formFiltroVisivel}
                  onFiltrarClick={this.onFiltrarClick}
                  onCancelarFiltroClick={this.onCancelarFiltroClick}
                  filtros={filtros}
                />


                <Col xs={2} style={{ width: 110, marginTop: -7 }}>
                  <VendasVendedoresPrintModal
                    filtros={filtros}
                    buscaMes={this.state.filtros.buscaMes}
                    buscaAno={this.state.filtros.buscaAno}
                  />
                </Col>

              </Row>

              {buscaMes ? (
                <Col xs={24} sm={8} style={{ marginTop: 10 }}>
                  <Col xs={24} sm={10} style={{ margin: 5, padding: 3, textAlign: "center", background: Colors.primaryLight, color: "white", borderRadius: 3 }} >
                    <Row><span style={{ fontWeight: "bold" }}>Vendas</span></Row>
                    <Row><span style={{ color: this.state.vendasTotais > this.state.meta ? "#FAFAFA" : "#b71c1c" }}>{this.renderValor(this.state.vendasTotais)}</span></Row>
                  </Col>
                  <Col xs={24} sm={10} style={{ margin: 5, padding: 3, textAlign: "center", background: Colors.primaryLight, color: "white", borderRadius: 3 }} >
                    <Row><span style={{ fontWeight: "bold" }}>Meta</span></Row>
                    <Row><span>{this.renderValor(this.state.meta)}</span></Row>
                  </Col>
                </Col>
              ) : (null)}

            </Col>

          </div>
        </Row>

        {buscaMes ? (
          <Row>
            <div style={{ marginTop: 10 }}>
              <Table
                pagination={false}
                onChange={this.onTabelaChange}
                loading={{
                  spinning: carregando,
                  tip: 'Carregando. Aguarde...',
                  size: "large"
                }}
                dataSource={listaRegistros}
                // scroll={{ x: 600 }}
                rowKey={(registro => registro.usu_cpf)}
              >
                <Column
                  key="usu_nome"
                  dataIndex="usu_nome"
                  title={this.renderTitulo("Nome Vendedor")}
                  onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                  width={"50%"}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="vendasTotais"
                  dataIndex="vendasTotais"
                  title={this.renderTitulo("Vendas")}
                  onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                  render={this.renderValor}
                  width={"15%"}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="meta"
                  dataIndex="meta"
                  title={this.renderTitulo("Meta")}
                  onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                  render={this.renderValor}
                  width={"15%"}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="meta1"
                  dataIndex="meta1"
                  title=""
                  render={this.renderResultado}
                  width={"25%"}
                  align="right"
                  className="listaCadastro"
                />
              </Table>
            </div>
          </Row>

        ) : (
          <Row>
            <div style={{ marginTop: 10 }}>
              <Table
                pagination={false}
                onChange={this.onTabelaChange}
                loading={{
                  spinning: carregando,
                  tip: 'Carregando. Aguarde...',
                  size: "large"
                }}
                dataSource={listaRegistros}
                // scroll={{ x: 600 }}
                rowKey={(registro => registro.usu_cpf)}
              >
                <Column
                  key="usu_nome"
                  dataIndex="usu_nome"
                  title={this.renderTitulo("Nome Vendedor")}
                  onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                  width={"10%"}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="vendas01"
                  dataIndex="vendas01"
                  title={this.renderTitulo("Jan")}
                  onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                  render={this.renderValor01}
                  width={"5%"}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="vendas02"
                  dataIndex="vendas02"
                  title={this.renderTitulo("Fev")}
                  onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                  render={this.renderValor02}
                  width={"5%"}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="vendas03"
                  dataIndex="vendas03"
                  title={this.renderTitulo("Mar")}
                  onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                  render={this.renderValor03}
                  width={"5%"}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="vendas04"
                  dataIndex="vendas04"
                  title={this.renderTitulo("Abr")}
                  onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                  render={this.renderValor04}
                  width={"5%"}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="vendas05"
                  dataIndex="vendas05"
                  title={this.renderTitulo("Mai")}
                  onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                  render={this.renderValor05}
                  width={"5%"}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="vendas06"
                  dataIndex="vendas06"
                  title={this.renderTitulo("Jun")}
                  onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                  render={this.renderValor06}
                  width={"5%"}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="vendas07"
                  dataIndex="vendas07"
                  title={this.renderTitulo("Jul")}
                  onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                  render={this.renderValor07}
                  width={"5%"}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="vendas08"
                  dataIndex="vendas08"
                  title={this.renderTitulo("Ago")}
                  onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                  render={this.renderValor08}
                  width={"5%"}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="vendas09"
                  dataIndex="vendas09"
                  title={this.renderTitulo("Set")}
                  onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                  render={this.renderValor09}
                  width={"5%"}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="vendas10"
                  dataIndex="vendas10"
                  title={this.renderTitulo("Out")}
                  onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                  render={this.renderValor10}
                  width={"5%"}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="vendas11"
                  dataIndex="vendas11"
                  title={this.renderTitulo("Nov")}
                  onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                  render={this.renderValor11}
                  width={"5%"}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="vendas12"
                  dataIndex="vendas12"
                  title={this.renderTitulo("Dez")}
                  onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                  render={this.renderValor12}
                  width={"5%"}
                  align="right"
                  className="listaCadastro"
                />
              </Table>
              <Row style={{ background: "#ececec", padding: 5, marginTop: 10, marginLeft: 220 }}>
                <Col xs={24} sm={2} style={{ paddingRight: 5, textAlign: "right", background: "white", fontSize: 13 }} >
                  <Row><span style={{ color: this.state.vlrJan > this.state.MetaJan ? "#10734a" : "#b71c1c" }}>{this.renderValor(this.state.vlrJan)}</span></Row>
                </Col>
                <Col xs={24} sm={2} style={{ paddingRight: 5, textAlign: "right", background: "white", fontSize: 13 }} >
                  <Row><span style={{ color: this.state.vlrFev > this.state.MetaFev ? "#10734a" : "#b71c1c" }}>{this.renderValor(this.state.vlrFev)}</span></Row>
                </Col>
                <Col xs={24} sm={2} style={{ paddingRight: 5, textAlign: "right", background: "white", fontSize: 13 }} >
                  <Row><span style={{ color: this.state.vlrMar > this.state.MetaMar ? "#10734a" : "#b71c1c" }}>{this.renderValor(this.state.vlrMar)}</span></Row>
                </Col>
                <Col xs={24} sm={2} style={{ paddingRight: 5, textAlign: "right", background: "white", fontSize: 13 }} >
                  <Row><span style={{ color: this.state.vlrAbr > this.state.MetaAbr ? "#10734a" : "#b71c1c" }}>{this.renderValor(this.state.vlrAbr)}</span></Row>
                </Col>
                <Col xs={24} sm={2} style={{ paddingRight: 5, textAlign: "right", background: "white", fontSize: 13 }} >
                  <Row><span style={{ color: this.state.vlrMai > this.state.MetaMai ? "#10734a" : "#b71c1c" }}>{this.renderValor(this.state.vlrMai)}</span></Row>
                </Col>
                <Col xs={24} sm={2} style={{ paddingRight: 5, textAlign: "right", background: "white", fontSize: 13 }} >
                  <Row><span style={{ color: this.state.vlrJun > this.state.MetaJun ? "#10734a" : "#b71c1c" }}>{this.renderValor(this.state.vlrJun)}</span></Row>
                </Col>
                <Col xs={24} sm={2} style={{ paddingRight: 5, textAlign: "right", background: "white", fontSize: 13 }} >
                  <Row><span style={{ color: this.state.vlrJul > this.state.MetaJul ? "#10734a" : "#b71c1c" }}>{this.renderValor(this.state.vlrJul)}</span></Row>
                </Col>
                <Col xs={24} sm={2} style={{ paddingRight: 5, textAlign: "right", background: "white", fontSize: 13 }} >
                  <Row><span style={{ color: this.state.vlrAgo > this.state.MetaAgo ? "#10734a" : "#b71c1c" }}>{this.renderValor(this.state.vlrAgo)}</span></Row>
                </Col>
                <Col xs={24} sm={2} style={{ paddingRight: 5, textAlign: "right", background: "white", fontSize: 13 }} >
                  <Row><span style={{ color: this.state.vlrSet > this.state.MetaSet ? "#10734a" : "#b71c1c" }}>{this.renderValor(this.state.vlrSet)}</span></Row>
                </Col>
                <Col xs={24} sm={2} style={{ paddingRight: 5, textAlign: "right", background: "white", fontSize: 13 }} >
                  <Row><span style={{ color: this.state.vlrOut > this.state.MetaOut ? "#10734a" : "#b71c1c" }}>{this.renderValor(this.state.vlrOut)}</span></Row>
                </Col>
                <Col xs={24} sm={2} style={{ paddingRight: 5, textAlign: "right", background: "white", fontSize: 13 }} >
                  <Row><span style={{ color: this.state.vlrNov > this.state.MetaNov ? "#10734a" : "#b71c1c" }}>{this.renderValor(this.state.vlrNov)}</span></Row>
                </Col>
                <Col xs={24} sm={2} style={{ paddingRight: 5, textAlign: "right", background: "white", fontSize: 13 }} >
                  <Row><span style={{ color: this.state.vlrDez > this.state.MetaDez ? "#10734a" : "#b71c1c" }}>{this.renderValor(this.state.vlrDez)}</span></Row>
                </Col>
              </Row>
            </div>
          </Row>
        )}
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/VendasVendedoresPage.js